import { useMutation } from "urql";

import { UpdateMessageTemplateDocument } from "../../../../graphql/generated.ts";

export function useUpdateMessageTemplate() {
  return useMutation(UpdateMessageTemplateDocument);
}
